import axios from "../../js/project-axios.js"

const list = subjectTypes => {
    return axios.get("/capital/account/list", {
        params: {
            subjectType: subjectTypes
        }
    });
};

const add = account => {
    return axios.post("/capital/account/add", account);
};

const update = account => {
    return axios.post("/capital/account/update", account);
};

const order = (id, nextId) => {
    return axios.post("/capital/account/order", {
        id,
        nextId
    });
};

export default {
    list,
    add,
    update,
    order
};